import { Image, Text, View } from "@aws-amplify/ui-react";
import { Grid, useMediaQuery } from "@mui/material";
import {
  slideFive,
  slideFour,
  slideOne,
  slideThree,
  slideTwo,
} from "constants/index";
import { motion } from "framer-motion";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function HomeSC() {
  const matches = useMediaQuery("(min-width:800px)");
  const mobilematches = useMediaQuery("(min-width:400px)");
  const handleDonationClicked = () => {
    window.open("https://donate.stripe.com/14kdSG6OF7Crcb65kk");
  };

  // const homeLogoRef = useRef(null)

  //   const { scrollYProgress } = useScroll(
  //     {
  //     target: homeLogoRef,
  //     offset: ["start start","end start"]
  //   },
  // )

  // const rotateAffect = useTransform(scrollYProgress, [0,1], ["0deg","360deg"])
  // const marginLeftAffect = useTransform(scrollYProgress, [0,1], ["0px","600px"])
  // const opacityAffect = useTransform(scrollYProgress, [0,1], ["1", "0.1"])

  // useMotionValueEvent(scrollYProgress, "change", (latest) => {
  //   console.log("Latest", latest)
  //   console.log("Scroll Progress", scrollYProgress.current)
  // })

  return (
    <Grid
      container
      display="flex"
      id="home"
      position="relative"
      height={"100vh"}
      width="100vw"
      direction="column"
      wrap="nowrap"
      overflow="scroll"
      // bgcolor="pink"
      paddingTop={2}
      // sx={{
      //   overflowX: "hidden",
      // }}
    >
      {/* Grid Images */}

      <View className="absolute flex justify-center pt-[115px] pl-32  w-full z-0 pr-10 ">
        <View className="relative flex flex-row gap-3 ">
          <View display={matches ? "" : "none"}>
            <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 5500,
              }}
              className="relative flex w-[350px] h-[500px] justify-self-end"
              // navigation
              // onSlideChange={() => console.log("slide changed..")}
            >
              {slideOne.map((src: any, index: number) => (
                <SwiperSlide key={index}>
                  <Image
                    alt={`slide-${index}`}
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </View>

          <View className="relative flex flex-col gap-3">
            <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 6500,
              }}
              className="relative flex w-[300px] h-[200px] justify-self-end"
              navigation
              // onSlideChange={() => console.log("slide changed..")}
            >
              {slideTwo.map((src: any, index: number) => (
                <SwiperSlide key={index}>
                  <Image
                    alt={`slide-${index}`}
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 3500,
              }}
              className="relative flex w-[300px] h-[300px] justify-self-end"
              navigation
              // onSlideChange={() => console.log("slide changed..")}
            >
              {slideThree.map((src: any, index: number) => (
                <SwiperSlide key={index}>
                  <Image
                    alt={`slide-${index}`}
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </View>
          <View className="relative flex flex-col gap-3">
            <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 6500,
              }}
              className="relative flex w-[350px] h-[250px] justify-self-end"
              navigation
              // onSlideChange={() => console.log("slide changed..")}
            >
              {slideFour.map((src: any, index: number) => (
                <SwiperSlide key={index}>
                  <Image
                    alt={`slide-${index}`}
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
            <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 3500,
              }}
              className="relative flex w-[350px] h-[300px] justify-self-end"
              navigation
              // onSlideChange={() => console.log("slide changed..")}
            >
              {slideFive.map((src: any, index: number) => (
                <SwiperSlide key={index}>
                  <Image
                    alt={`slide-${index}`}
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </View>
        </View>
      </View>

      {/* Grind Images */}

      {/* <motion.div
              ref={homeLogoRef}
              style={{
                rotate: rotateAffect,
                marginLeft: marginLeftAffect,
                scale: opacityAffect
              }}
              className='relative flex w-[210px] min-h-[200px] max-h-[600px] overflow-hidden '
              initial={{
                rotate: '0deg',
                marginLeft: "-200px",
                position:"relative"
              }}
              animate={{
                rotate:"360deg",
                marginLeft: "0px"
        
              }}
        
              // exit={{
              //   marginLeft:"1000px",
              //   rotate:"0deg",
        
              // }}
              
              transition={{
                duration: 3,
                type:"spring"
               
              }} 
              > */}
      <View className="relative px-5 pt-20  w-[280px]  ">
        <Image
          display={mobilematches ? "" : "none"}
          src="/EHRLogo.png"
          alt="about logo"
          width="200px"
          height="330px"
          objectFit="cover"
          position="relative"
        />
      </View>
      {/* </motion.div> */}

      {/* // EHR FOR The HOOD plus buttons section */}
      <Grid
        container
        item
        position="relative"
        display="flex"
        direction="column"
        height="100%"
        className="  justify-end pb-24"
        // backgroundColor="blue"
        wrap="nowrap"
      >
        <section
          className="flex flex-col font-[5px]  pt-5 pb-5  pl-8 pr-8  gap-5
        
        bg-[rgba(41,46,41,0.8)] p-6  shadow-2xl
        "
        >
          {/* <motion.section
                
                initial={{
                
              
              
              
                
        
                  opacity: 0.2,
                  scale: 0.8
                  
                }}
                whileInView={{
                  opacity: 1,
                  scale: 1
                  
                 
                  
                }}
                
                transition={{ duration: 2 }}>
        
                
                 */}
          <View
            className="relative flex sm:text-3xl md:text-[63px] flex-wrap text-wrap "
            fontSize={matches ? "45px" : "35px"}
            color="white"
          >
            <div
              className="font-lolita-one"
              style={
                {
                  // flexWrap: "wrap",
                  // wordWrap: "break-word",
                  // overflowWrap: "anywhere",
                }
              }
              color="white"
            >
              ENVIRONMENTAL HOOD RESTORATION
            </div>
          </View>
          <div className="  sm:text-xl text-white sm:pt-0 md:text-[26px] md:pt-0 font-lolita-one">
            FOR THE HOOD, FROM THE HOOD.
          </div>
          {/* </motion.section> */}
        </section>

        {/* Upcoming Events and Donte button Grid */}
        <Grid
          item
          display="flex"
          paddingTop="25px"
          paddingLeft="25px"
          paddingRight="25px"
          // direction={matches ? "row" : "column"}

          width="100%"
          alignItems="flex-start"
          gap="15px"
        >
          {/* <a href='#upcoming-events'> */}
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => {
              const upcomingEvent = document.getElementById("about");
              if (upcomingEvent) {
                upcomingEvent.scrollIntoView({ behavior: "smooth" });
              }
              // setshowFlyer(true)
            }}
          >
            <Text
              display="flex"
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
              width="160px"
              height="60px"
              backgroundColor="rgba(32, 78, 41, 0.8)"
              borderRadius="5px"
              textAlign="center"
              fontWeight="bold"
              // fontFamily="lolita-one"
              color="white"
              fontSize={20}
              // className="font-lolita-one"
            >
              <div className=" font-lolita-one">About Us</div>
            </Text>
          </motion.button>
          {/* </a> */}

          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleDonationClicked}
          >
            <Text
              display="flex"
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
              width="160px"
              height="60px"
              backgroundColor="rgba(32, 78, 41, 0.8)"
              borderRadius="5px"
              fontWeight="bold"
              fontSize={20}
              color="white"
              className="focus:border-green active:border-green "
            >
              <div className=" font-lolita-one">Donate</div>
            </Text>
          </motion.button>
        </Grid>
      </Grid>
    </Grid>
  );
}
